// Header.js

const Header = () => {


    return (
        <header className="flexing wrapper">
            <h1>Jeopardy Master</h1>
            <h2>Welcome To Jeopardy!</h2>
        </header>
    )
}

export default Header;